import React from "react";
import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout, Login, Portal, Peak } from "./pages";
import Home from './Home.jsx';
import "./App.css";
import {RequireAuth} from "./RequireAuth";
import { RequireAdmin } from "./RequireAdmin";

const App = () => {
    return (
      <Routes>
          <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="login" element={<Login />} />
              <Route path="portal" element={<RequireAuth><Portal /></RequireAuth>} />
              <Route path="peak" element={<RequireAdmin><Peak /></RequireAdmin>} />
              <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
      </Routes>
    );
};

export default App;
